/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ListKeyManager } from '@angular/cdk/a11y';
import { Component, EventEmitter, HostBinding, HostListener, Input, Output, ViewChild, ViewChildren, } from '@angular/core';
import { addMonths, addWeeks, eachDay, endOfMonth, format, getDate, getDay, getMonth, getYear, isSameDay, isSameMonth, isSameYear, isToday, parse, setDate, setDay, setYear, startOfMonth, subDays, subMonths, subWeeks, } from 'date-fns';
import { DatepickerPosition } from './models';
import * as i0 from "@angular/core";
import * as i1 from "./datepicker.options";
import * as i2 from "@angular/cdk/a11y";
import * as i3 from "@angular/common";
const _c0 = ["dateInputField"];
const _c1 = ["focusable"];
const _c2 = ["daybutton"];
function DatepickerCalendarComponent_div_14_th_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 15)(1, "span", 16);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const name_r6 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("title", name_r6);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", ctx_r4.fullDayNames[name_r6]);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(name_r6);
} }
const _c3 = function (a0, a1, a2, a3, a4, a5, a6, a7) { return { "btn-tertiary": a0, "btn-secondary": a1, active: a2, focus: a3, "is-today": a4, "btn-primary": a5, "is-selected": a6, "is-disabled": a7 }; };
function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21, 22);
    i0.ɵɵlistener("click", function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_0_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r19); const j_r12 = i0.ɵɵnextContext(2).index; const ctx_r18 = i0.ɵɵnextContext(2); const day_r7 = ctx_r18.$implicit; const i_r8 = ctx_r18.index; const ctx_r17 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(day_r7.isSelectable && ctx_r17.setDate(i_r8 + j_r12)); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r12 = i0.ɵɵnextContext(2).index;
    const i_r8 = i0.ɵɵnextContext(2).index;
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(3, _c3, !ctx_r14.days[i_r8 + j_r12].isToday && !ctx_r14.days[i_r8 + j_r12].isSelected, ctx_r14.days[i_r8 + j_r12].isToday, ctx_r14.days[i_r8 + j_r12].isToday, ctx_r14.days[i_r8 + j_r12].isToday, ctx_r14.days[i_r8 + j_r12].isToday, ctx_r14.days[i_r8 + j_r12].isSelected, ctx_r14.days[i_r8 + j_r12].isSelected, !ctx_r14.days[i_r8 + j_r12].isSelectable));
    i0.ɵɵattribute("aria-label", ctx_r14.getScreenReaderDate(ctx_r14.days[i_r8 + j_r12]));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.days[i_r8 + j_r12].day, " ");
} }
function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 21, 23);
    i0.ɵɵlistener("click", function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r27); const j_r12 = i0.ɵɵnextContext(2).index; const ctx_r26 = i0.ɵɵnextContext(2); const day_r7 = ctx_r26.$implicit; const i_r8 = ctx_r26.index; const ctx_r25 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(day_r7.isSelectable && ctx_r25.setDate(i_r8 + j_r12)); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const j_r12 = i0.ɵɵnextContext(2).index;
    const i_r8 = i0.ɵɵnextContext(2).index;
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction8(3, _c3, !ctx_r15.days[i_r8 + j_r12].isToday && !ctx_r15.days[i_r8 + j_r12].isSelected, ctx_r15.days[i_r8 + j_r12].isToday, ctx_r15.days[i_r8 + j_r12].isToday, ctx_r15.days[i_r8 + j_r12].isToday, ctx_r15.days[i_r8 + j_r12].isToday, ctx_r15.days[i_r8 + j_r12].isSelected, ctx_r15.days[i_r8 + j_r12].isSelected, !ctx_r15.days[i_r8 + j_r12].isSelectable));
    i0.ɵɵattribute("aria-label", ctx_r15.getScreenReaderDate(ctx_r15.days[i_r8 + j_r12]));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.days[i_r8 + j_r12].day, " ");
} }
function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_0_Template, 4, 12, "ng-container", 20);
    i0.ɵɵtemplate(1, DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_ng_container_1_Template, 5, 12, "ng-container", 20);
} if (rf & 2) {
    const j_r12 = i0.ɵɵnextContext().index;
    const i_r8 = i0.ɵɵnextContext(2).index;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngIf", !ctx_r13.isInNavQueue(ctx_r13.days[i_r8 + j_r12]));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r13.isInNavQueue(ctx_r13.days[i_r8 + j_r12]));
} }
function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 19);
    i0.ɵɵtemplate(1, DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_ng_template_1_Template, 2, 2, "ng-template", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const j_r12 = ctx.index;
    const i_r8 = i0.ɵɵnextContext(2).index;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.days[i_r8 + j_r12] && ctx_r10.days[i_r8 + j_r12].inThisMonth);
} }
function DatepickerCalendarComponent_div_14_tr_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, DatepickerCalendarComponent_div_14_tr_6_ng_template_1_td_0_Template, 2, 1, "td", 18);
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngForOf", ctx_r9.dayNames);
} }
function DatepickerCalendarComponent_div_14_tr_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, DatepickerCalendarComponent_div_14_tr_6_ng_template_1_Template, 1, 1, "ng-template", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r8 = ctx.index;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r8 % 7 === 0);
} }
function DatepickerCalendarComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11)(1, "table", 12)(2, "thead")(3, "tr");
    i0.ɵɵtemplate(4, DatepickerCalendarComponent_div_14_th_4_Template, 3, 3, "th", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "tbody");
    i0.ɵɵtemplate(6, DatepickerCalendarComponent_div_14_tr_6_Template, 2, 1, "tr", 14);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.dayNames);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r2.days);
} }
// Counter for calculating the auto-incrementing field ID
// let counter = 0;
/**
 * Internal library helper that helps to check if value is empty
 */
const isNil = (selectedValue) => {
    return typeof selectedValue === 'undefined' || selectedValue === null;
};
const CURRENT_DAY_CLASS = 'is-today';
const SELECTED_DAY_CLASS = 'is-selected';
export class DatepickerCalendarComponent {
    constructor(options, liveAnnouncer) {
        this.options = options;
        this.liveAnnouncer = liveAnnouncer;
        this.closeOnBlur = false;
        this.headless = false;
        this.isOpened = true;
        this.isComponent = false;
        this.position = DatepickerPosition.Bottom;
        this.label = 'Date';
        this.dateSelected = new EventEmitter();
        // eslint-disable-next-line @angular-eslint/no-output-native
        this.close = new EventEmitter();
        this.currentCalendarDay = { el: undefined, index: null };
        this.selectedCalendarDay = { el: undefined, index: null };
        this.needsReIndex = false;
        this.onTouchedCallback = () => { };
        this.onChangeCallback = () => { };
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    get selectedValue() {
        return this.innerValue;
    }
    set selectedValue(val) {
        this.innerValue = val;
        this.onChangeCallback(this.innerValue);
    }
    ngOnInit() {
        this.view = 'days';
        this.date = this.selectedValue || new Date();
        this.setOptions();
        this.initDayNames();
        this.init();
        this.initYears();
    }
    ngOnChanges(changes) {
        if (!changes.innerValue.firstChange) {
            this.setOptions();
            this.initDayNames();
            this.init();
            this.initYears();
        }
    }
    ngAfterViewInit() {
        this.dayManager = new ListKeyManager(this.dayLinks);
        this.navManager = new ListKeyManager(this.navLinks).withWrap();
        this.defaultDaySelection = { item: this.dayLinks.first, index: 0 };
        this.initKeyManager();
    }
    ngAfterViewChecked() {
        if (this.needsReIndex) {
            this.initKeyManager();
            this.needsReIndex = false;
        }
    }
    setDayIndicies() {
        this.dayLinks.forEach((el, i) => {
            if (el.nativeElement.classList.contains(CURRENT_DAY_CLASS)) {
                this.currentDayIndex = i;
            }
            if (el.nativeElement.classList.contains(SELECTED_DAY_CLASS)) {
                this.selectedDayIndex = i;
            }
        });
    }
    isInNavQueue(day) {
        const today = new Date();
        const monthHasSelection = day.month === parse(this.innerValue).getMonth();
        if (!monthHasSelection && day.day === 1 && day.month !== getMonth(today)) {
            return true;
        }
        if (day.isSelected) {
            return true;
        }
        if (day.isToday) {
            return true;
        }
        return undefined;
    }
    initKeyManager() {
        const token = this.selectedValue ? 'is-selected' : 'is-today';
        const focusable = this.defaultDaySelection === 'first'
            ? { item: this.dayLinks.first, index: 0 }
            : { item: this.dayLinks.last, index: this.dayLinks.length };
        this.dayLinks.forEach((item, index) => {
            if (item.nativeElement.classList.contains(token)) {
                focusable.item = item;
                focusable.index = index;
            }
        });
        this.dayManager.setActiveItem(focusable.index);
        this.navManager.setActiveItem(2); // always set tab focus to the date
        focusable.item.nativeElement.focus();
    }
    setOptions() {
        const today = new Date();
        this.minYear = getYear(today) - 30;
        this.maxYear = getYear(today) + 30;
        this.barTitleFormat = 'MMMM YYYY';
        this.dayNamesFormat = 'dd';
        this.firstCalendarDay = 0;
        this.locale = {};
        this.dateFormat = (this.options && this.options.dateFormat) || this.dateFormat || 'MMM D[,] YYYY';
    }
    getSRNextMonth() {
        const nextMonthDate = addMonths(this.date, 1);
        return 'Next month ' + format(nextMonthDate, 'MMMM YYYY');
    }
    getSRPrevMonth() {
        const prevMonthDate = subMonths(this.date, 1);
        return 'Previous month ' + format(prevMonthDate, 'MMMM YYYY');
    }
    nextMonth() {
        this.defaultDaySelection = 'first';
        this.date = addMonths(this.date, 1);
        this.init();
    }
    nextWeek() {
        const activeDate = setDate(this.date, (this.dayManager.activeItemIndex || 0) + 1);
        const nextWeek = addWeeks(activeDate, 1);
        this.date = nextWeek;
        this.init();
        setTimeout(() => {
            const selectableItem = this.dayLinks.find((item, i) => {
                if (i === getDate(nextWeek) - 1) {
                    return item;
                }
            });
            if (selectableItem) {
                this.dayManager.setActiveItem(selectableItem);
                this.dayManager.activeItem.nativeElement.focus();
            }
        }, 0);
    }
    prevMonth() {
        this.defaultDaySelection = 'first';
        this.date = subMonths(this.date, 1);
        this.init();
    }
    prevWeek() {
        const activeDate = setDate(this.date, (this.dayManager.activeItemIndex || 0) + 1);
        const prevWeek = subWeeks(activeDate, 1);
        this.date = prevWeek;
        this.init();
        setTimeout(() => {
            const selectableItem = this.dayLinks.find((item, i) => {
                if (i === getDate(prevWeek) - 1) {
                    return item;
                }
            });
            if (selectableItem) {
                this.dayManager.setActiveItem(selectableItem);
                this.dayManager.activeItem.nativeElement.focus();
            }
        }, 0);
    }
    setDate(i) {
        this.date = this.days[i].date;
        this.selectedValue = this.date;
        this.setDayIndicies();
        this.init();
        const date = this.date;
        const dateString = format(this.date, this.dateFormat, this.locale);
        const dateSelectedEvent = { date, dateString, valid: true };
        this.onDateChange(dateSelectedEvent);
    }
    setYear(i) {
        this.date = setYear(this.date, this.years[i].year);
        this.init();
        this.initYears();
        this.view = 'days';
    }
    /**
     * @TODO add minDate, maxDate @Inputs() in UIK-253
     */
    isDateSelectable(date) {
        if (isNil(this.options)) {
            return true;
        }
        const minDateSet = !isNil(this.minDate);
        const maxDateSet = !isNil(this.maxDate);
        const timestamp = date.valueOf();
        if (minDateSet && timestamp < this.minDate.valueOf()) {
            return false;
        }
        if (maxDateSet && timestamp > this.maxDate.valueOf()) {
            return false;
        }
        return true;
    }
    init() {
        // this.date may be null after .reset(); fall back to current date.
        const actualDate = this.date || new Date();
        const start = startOfMonth(actualDate);
        const end = endOfMonth(actualDate);
        this.days = eachDay(start, end).map((date) => {
            return {
                date,
                day: getDate(date),
                month: getMonth(date),
                year: getYear(date),
                inThisMonth: true,
                isToday: isToday(date),
                isSelected: isSameDay(date, this.innerValue) &&
                    isSameMonth(date, this.innerValue) &&
                    isSameYear(date, this.innerValue),
                isSelectable: this.isDateSelectable(date),
            };
        });
        const tmp = getDay(start) - this.firstCalendarDay;
        const prevDays = tmp < 0 ? 7 - this.firstCalendarDay : tmp;
        for (let i = 1; i <= prevDays; i++) {
            const date = subDays(start, i);
            this.days.unshift({
                date,
                day: getDate(date),
                month: getMonth(date),
                year: getYear(date),
                inThisMonth: false,
                isToday: isToday(date),
                isSelected: isSameDay(date, this.innerValue) &&
                    isSameMonth(date, this.innerValue) &&
                    isSameYear(date, this.innerValue),
                isSelectable: this.isDateSelectable(date),
            });
        }
        this.barTitle = format(start, this.barTitleFormat, this.locale);
    }
    initYears() {
        const range = this.maxYear - this.minYear;
        this.years = Array.from(new Array(range), (x, i) => i + this.minYear).map((year) => {
            return { year, isThisYear: year === getYear(this.date) };
        });
    }
    initDayNames() {
        this.dayNames = [];
        this.fullDayNames = {};
        const start = this.firstCalendarDay;
        for (let i = start; i <= 6 + start; i++) {
            const date = setDay(new Date(), i);
            const formattedDayName = format(date, this.dayNamesFormat, this.locale);
            this.dayNames.push(formattedDayName);
            this.fullDayNames[formattedDayName] = format(date, 'dddd', this.locale);
        }
    }
    /**
     * @TODO add back this view in UIK-254
     */
    toggleView() {
        this.view = this.view === 'days' ? 'years' : 'days';
    }
    toggle() {
        if (!this.isOpened && this.view === 'years') {
            this.toggleView();
        }
    }
    onClose() {
        if (this.options.close) {
            this.options.close();
        }
        this.close.emit();
    }
    onDateChange(dateChangeEvent) {
        if (this.options.onDateChange) {
            this.options.onDateChange(dateChangeEvent);
        }
        this.dateSelected.emit(dateChangeEvent);
    }
    reset(fireValueChangeEvent = false) {
        this.date = null;
        this.innerValue = null;
        this.init();
    }
    writeValue(val) {
        if (val) {
            this.date = val;
            this.innerValue = val;
            this.init();
            this.displayValue = format(this.innerValue, this.dateFormat, this.locale);
            this.barTitle = format(startOfMonth(val), this.barTitleFormat, this.locale);
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    getScreenReaderDate(day) {
        let datePrefix = '';
        if (day.isSelected && day.isToday) {
            datePrefix = 'Current and selected date, ';
        }
        else if (day.isSelected) {
            datePrefix = 'Selected date, ';
        }
        else if (day.isToday) {
            datePrefix = 'Current date, ';
        }
        return datePrefix + format(day.date, this.SRDateFormat);
    }
    onKeyDownHandler(e) {
        let selectableItem = null;
        if (!this.isOpened) {
            return;
        }
        if (!this.currentDayIndex) {
            this.setDayIndicies();
        }
        if (this.innerValue && !this.selectedDayIndex) {
            this.setDayIndicies();
        }
        if (e.key === 'Tab' && e.shiftKey) {
            this.navManager.setPreviousItemActive();
            if (this.navManager.activeItem) {
                this.navManager.activeItem.nativeElement.focus();
            }
            e.preventDefault();
            return;
        }
        switch (e.key) {
            case 'Tab':
                let selectable = null;
                let index = 0;
                if (this.innerValue) {
                    index = this.selectedDayIndex;
                    selectable = SELECTED_DAY_CLASS;
                }
                else {
                    index = this.currentDayIndex;
                    selectable = CURRENT_DAY_CLASS;
                }
                this.navManager.setNextItemActive();
                this.navManager.activeItem.nativeElement.focus();
                if (this.navManager.activeItem.nativeElement.classList.contains(selectable)) {
                    this.dayManager.setActiveItem(index);
                    this.dayManager.activeItem.nativeElement.focus();
                }
                e.preventDefault();
                break;
            case 'ArrowRight':
                if ((this.dayManager.activeItemIndex || 0) + 1 >= this.dayLinks.length) {
                    this.defaultDaySelection = { item: this.dayLinks.first, index: 0 };
                    this.needsReIndex = true;
                    this.nextMonth();
                }
                else {
                    this.dayManager.setNextItemActive();
                    this.dayManager.activeItem.nativeElement.focus();
                }
                break;
            case 'ArrowLeft':
                if (this.dayManager.activeItemIndex === 0) {
                    this.defaultDaySelection = { item: this.dayLinks.last, index: this.dayLinks.length };
                    this.needsReIndex = true;
                    this.prevMonth();
                }
                this.dayManager.setPreviousItemActive();
                this.dayManager.activeItem.nativeElement.focus();
                break;
            case 'ArrowDown':
                selectableItem = this.dayLinks.find((item, i) => {
                    if (i === (this.dayManager.activeItemIndex || 0) + 7) {
                        return item;
                    }
                });
                if (selectableItem) {
                    this.dayManager.setActiveItem(selectableItem);
                    this.dayManager.activeItem.nativeElement.focus();
                }
                else {
                    this.nextWeek();
                }
                e.preventDefault();
                break;
            case 'ArrowUp':
                selectableItem = this.dayLinks.find((item, i) => {
                    if (i === (this.dayManager.activeItemIndex || 0) - 7) {
                        return item;
                    }
                });
                if (selectableItem) {
                    this.dayManager.setActiveItem(selectableItem);
                    this.dayManager.activeItem.nativeElement.focus();
                }
                else {
                    this.prevWeek();
                }
                e.preventDefault();
                break;
            case 'Escape':
                this.onClose();
                break;
        }
    }
    get popoverId() {
        return this.id;
    }
    onChange(event) {
        this.selectedValue = parse(event.target.value);
        this.date = parse(event.target.value);
    }
}
DatepickerCalendarComponent.ɵfac = function DatepickerCalendarComponent_Factory(t) { return new (t || DatepickerCalendarComponent)(i0.ɵɵdirectiveInject(i1.DatepickerOptions), i0.ɵɵdirectiveInject(i2.LiveAnnouncer)); };
DatepickerCalendarComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DatepickerCalendarComponent, selectors: [["mhe-datepicker-calendar"]], viewQuery: function DatepickerCalendarComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dateInputField = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.navLinks = _t);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dayLinks = _t);
    } }, hostVars: 1, hostBindings: function DatepickerCalendarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keydown", function DatepickerCalendarComponent_keydown_HostBindingHandler($event) { return ctx.onKeyDownHandler($event); }, false, i0.ɵɵresolveDocument);
    } if (rf & 2) {
        i0.ɵɵattribute("id", ctx.popoverId);
    } }, inputs: { closeOnBlur: "closeOnBlur", dateFormat: "dateFormat", SRDateFormat: "SRDateFormat", headless: "headless", isOpened: "isOpened", isComponent: "isComponent", position: "position", label: "label", innerValue: "innerValue" }, outputs: { dateSelected: "dateSelected", close: "close" }, features: [i0.ɵɵNgOnChangesFeature], decls: 19, vars: 9, consts: [["role", "dialog", 1, "ngx-datepicker-calendar-container"], [1, "topbar-container"], ["type", "button", 1, "btn", "btn-tertiary", "prev-month", 3, "title", "click"], ["focusable", ""], [1, "icon-left"], [1, "sr-only"], ["type", "button", 1, "btn", "btn-tertiary", "next-month", 3, "title", "click"], [1, "icon-right"], ["class", "main-calendar-container", 4, "ngIf"], [1, "bottombar-container"], ["type", "button", "aria-label", "close calendar", 1, "btn", "btn-tertiary", 3, "click"], [1, "main-calendar-container"], ["role", "presentation"], ["scope", "col", 3, "title", 4, "ngFor", "ngForOf"], [4, "ngFor", "ngForOf"], ["scope", "col", 3, "title"], [1, "day-name-unit", 3, "title"], [3, "ngIf"], ["class", "main-calendar-days", 4, "ngFor", "ngForOf"], [1, "main-calendar-days"], [4, "ngIf"], ["type", "button", 1, "btn", "day-unit", 3, "ngClass", "click"], ["daybutton", ""], ["focusable", "", "daybutton", ""]], template: function DatepickerCalendarComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0)(2, "div", 1)(3, "button", 2, 3);
        i0.ɵɵlistener("click", function DatepickerCalendarComponent_Template_button_click_3_listener() { return ctx.prevMonth(); });
        i0.ɵɵelement(5, "i", 4);
        i0.ɵɵelementStart(6, "span", 5);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd()();
        i0.ɵɵtext(8);
        i0.ɵɵelementStart(9, "button", 6, 3);
        i0.ɵɵlistener("click", function DatepickerCalendarComponent_Template_button_click_9_listener() { return ctx.nextMonth(); });
        i0.ɵɵelementStart(11, "span", 5);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "i", 7);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(14, DatepickerCalendarComponent_div_14_Template, 7, 2, "div", 8);
        i0.ɵɵelementStart(15, "div", 9)(16, "button", 10, 3);
        i0.ɵɵlistener("click", function DatepickerCalendarComponent_Template_button_click_16_listener() { return ctx.onClose(); });
        i0.ɵɵtext(18, " Close ");
        i0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        i0.ɵɵclassMapInterpolate1("ngx-datepicker-container ngx-datepicker-position-", ctx.position, "");
        i0.ɵɵadvance(3);
        i0.ɵɵpropertyInterpolate("title", ctx.getSRPrevMonth());
        i0.ɵɵadvance(4);
        i0.ɵɵtextInterpolate(ctx.getSRPrevMonth());
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.barTitle, " ");
        i0.ɵɵadvance(1);
        i0.ɵɵpropertyInterpolate("title", ctx.getSRNextMonth());
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.getSRNextMonth());
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.days.length > 0);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DatepickerCalendarComponent, [{
        type: Component,
        args: [{ selector: 'mhe-datepicker-calendar', template: "<div class=\"ngx-datepicker-container ngx-datepicker-position-{{ position }}\">\n  <div class=\"ngx-datepicker-calendar-container\" role=\"dialog\">\n    <div class=\"topbar-container\">\n      <button\n        #focusable\n        (click)=\"prevMonth()\"\n        type=\"button\"\n        class=\"btn btn-tertiary prev-month\"\n        title=\"{{ getSRPrevMonth() }}\"\n      >\n        <i class=\"icon-left\"></i><span class=\"sr-only\">{{ getSRPrevMonth() }}</span>\n      </button>\n      {{ barTitle }}\n      <button\n        #focusable\n        (click)=\"nextMonth()\"\n        type=\"button\"\n        class=\"btn btn-tertiary next-month\"\n        title=\"{{ getSRNextMonth() }}\"\n      >\n        <span class=\"sr-only\">{{ getSRNextMonth() }}</span>\n        <i class=\"icon-right\"></i>\n      </button>\n    </div>\n    <div class=\"main-calendar-container\" *ngIf=\"days.length > 0\">\n      <table role=\"presentation\">\n        <thead>\n          <tr>\n            <th scope=\"col\" *ngFor=\"let name of dayNames\" title=\"{{ name }}\">\n              <span class=\"day-name-unit\" title=\"{{ fullDayNames[name] }}\">{{ name }}</span>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <tr *ngFor=\"let day of days; let i = index\">\n            <ng-template [ngIf]=\"i % 7 === 0\">\n              <td *ngFor=\"let name of dayNames; let j = index\" class=\"main-calendar-days\">\n                <ng-template [ngIf]=\"days[i + j] && days[i + j].inThisMonth\">\n                  <ng-container *ngIf=\"!isInNavQueue(days[i + j])\">\n                    <button\n                      type=\"button\"\n                      #daybutton\n                      [attr.aria-label]=\"getScreenReaderDate(days[i + j])\"\n                      (click)=\"day.isSelectable && setDate(i + j)\"\n                      class=\"btn day-unit\"\n                      [ngClass]=\"{\n                        'btn-tertiary': !days[i + j].isToday && !days[i + j].isSelected,\n                        'btn-secondary': days[i + j].isToday,\n                        active: days[i + j].isToday,\n                        focus: days[i + j].isToday,\n                        'is-today': days[i + j].isToday,\n                        'btn-primary': days[i + j].isSelected,\n                        'is-selected': days[i + j].isSelected,\n                        'is-disabled': !days[i + j].isSelectable\n                      }\"\n                    >\n                      {{ days[i + j].day }}\n                    </button>\n                  </ng-container>\n                  <ng-container *ngIf=\"isInNavQueue(days[i + j])\">\n                    <button\n                      type=\"button\"\n                      #focusable\n                      #daybutton\n                      [attr.aria-label]=\"getScreenReaderDate(days[i + j])\"\n                      (click)=\"day.isSelectable && setDate(i + j)\"\n                      class=\"btn day-unit\"\n                      [ngClass]=\"{\n                        'btn-tertiary': !days[i + j].isToday && !days[i + j].isSelected,\n                        'btn-secondary': days[i + j].isToday,\n                        active: days[i + j].isToday,\n                        focus: days[i + j].isToday,\n                        'is-today': days[i + j].isToday,\n                        'btn-primary': days[i + j].isSelected,\n                        'is-selected': days[i + j].isSelected,\n                        'is-disabled': !days[i + j].isSelectable\n                      }\"\n                    >\n                      {{ days[i + j].day }}\n                    </button>\n                  </ng-container>\n                </ng-template>\n              </td>\n            </ng-template>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"bottombar-container\">\n      <button\n        #focusable\n        (click)=\"onClose()\"\n        type=\"button\"\n        class=\"btn btn-tertiary\"\n        aria-label=\"close calendar\"\n      >\n        Close\n      </button>\n    </div>\n  </div>\n</div>\n", styles: ["/*# sourceMappingURL=datepicker.component.css.map */\n"] }]
    }], function () { return [{ type: i1.DatepickerOptions }, { type: i2.LiveAnnouncer }]; }, { closeOnBlur: [{
            type: Input
        }], dateFormat: [{
            type: Input
        }], SRDateFormat: [{
            type: Input
        }], headless: [{
            type: Input
        }], isOpened: [{
            type: Input
        }], isComponent: [{
            type: Input
        }], position: [{
            type: Input
        }], label: [{
            type: Input
        }], innerValue: [{
            type: Input
        }], dateSelected: [{
            type: Output
        }], close: [{
            type: Output
        }], navLinks: [{
            type: ViewChildren,
            args: ['focusable']
        }], dayLinks: [{
            type: ViewChildren,
            args: ['daybutton']
        }], dateInputField: [{
            type: ViewChild,
            args: ['dateInputField']
        }], onKeyDownHandler: [{
            type: HostListener,
            args: ['document:keydown', ['$event']]
        }], popoverId: [{
            type: HostBinding,
            args: ['attr.id']
        }] }); })();
